import {
  Box,
  Text,
  Image,
  Heading,
  VStack,
  SimpleGrid,
  HStack,
  Link,
  Icon,
  Divider,
  Flex,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";
import { FaX } from "react-icons/fa6";
import { founders, team, creativeTeam } from "./TeamData";

// Import your images here
import foundersImage from "../../../assets/home/yellowc.png"; // Left of "Our Founders"
import jugaduImage from "../../../assets/home/badgered.png"; // Right of "The Jugadu Bande"
import creativeImage from "../../../assets/home/bluebadge.png"; // Left of "The Creative Bande"

const TeamCard = ({ member, showSocial }) => (
  <VStack spacing={2} align="center" w="300px" mx="auto">
    <Image
      src={member.image}
      alt={member.name}
      borderRadius="md"
      w="300px"
      h="300px"
      objectFit="cover"
      bg="gray.200"
      className="fade-in-up"
    />

    <Box textAlign="center" w="300px">
      <Heading fontSize="md" fontWeight="bold" className="fade-in-up">
        {member.name}
      </Heading>
      <Text fontSize="sm" color="gray.600" className="fade-in-up">
        {member.role}
      </Text>
      <Text fontSize="xs" color="gray.500" px={2} className="fade-in-up">
        {member.description}
      </Text>

      {showSocial && (
        <HStack justify="center" spacing={4} mt={2}>
          <Link href={member.linkedin} isExternal>
            <Icon as={FaLinkedin} boxSize={5} />
          </Link>
          <Link href={member.instagram} isExternal>
            <Icon as={FaX} boxSize={5} />
          </Link>
        </HStack>
      )}
    </Box>
  </VStack>
);

const TeamDetail = () => {
  return (
    <Box py={10} px={{ base: 4, md: 10 }} maxW="7xl" mx="auto">
      {/* Our Founders Section */}
      <VStack spacing={2} mb={10}>
        <Flex align="center" justify="center">
          <Image src={foundersImage} alt="Founders" w="100px" mr={2} data-animated = 'true'/>
          <Text fontSize="xl" fontWeight="semibold" textAlign="center" color="blue.700" className="fade-in-up">
            Our Founders
          </Text>
        </Flex>
        <Text fontSize="xl" fontWeight="bold" textAlign="center" color="orange.400" className="fade-in-up">
          Seth-ji of Doggle India
        </Text>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} w="full" justifyItems="center">
          {founders.map((person, idx) => (
            <TeamCard key={idx} member={person} showSocial={true} />
          ))}
        </SimpleGrid>
      </VStack>

      <Divider borderColor="black" my={6} />
      <Text fontSize="md" textAlign="center" color="black" fontWeight="medium" className="fade-in-up">
        From designing jaw-dropping creatives to running high-converting campaigns, 
        this crazy bunch makes digital magic happen. Meet the wizards behind the screen:
      </Text>

      {/* The Jugadu Bande Section */}
      <VStack spacing={6} mt={10}>
        <Flex align="center" justify="center">
          <Text fontSize="xl" fontWeight="semibold" textAlign="center">
            <Text as="span" color="#005770" fontWeight="bold" className="fade-in-up">
              The{" "}
            </Text>
            <Text as="span" color="orange.400" fontWeight="bold" className="fade-in-up">
              Jugadu Bande
            </Text>
          </Text>
          <Image src={jugaduImage} alt="Jugadu" w="60px" ml={2} data-animated = 'true'/>
        </Flex>

        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6} w="full" justifyItems="center">
          {team.map((member, idx) => (
            <TeamCard key={idx} member={member} showSocial={false} />
          ))}
        </SimpleGrid>
      </VStack>

      {/* The Creative Bande Section */}
      <VStack spacing={6} mt={10}>
        <Flex align="center" justify="center">
          <Image src={creativeImage} alt="Creative" w="60px" mr={2} data-animated = 'true' />
          <Text fontSize="xl" fontWeight="semibold" textAlign="center">
            <Text as="span" color="#005770" fontWeight="bold">
              The{" "}
            </Text>
            <Text as="span" color="orange.400" fontWeight="bold">
              Creative Bande
            </Text>
          </Text>
        </Flex>

        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6} w="full" justifyItems="center">
          {creativeTeam.map((member, idx) => (
            <TeamCard key={idx} member={member} showSocial={false} />
          ))}
        </SimpleGrid>
      </VStack>
    </Box>
  );
};

export default TeamDetail;
